import { jsx as _jsx } from "react/jsx-runtime";
import { useCurrencyIcon } from '../../Contexts/CurrenciesContext';
export var CurrencyIcon = function (_a) {
    var a3 = _a.a3, _b = _a.diameter, diameter = _b === void 0 ? 24 : _b;
    var icon = useCurrencyIcon(a3);
    return _jsx("img", { width: diameter, height: diameter, src: icon });
};
